app.factory('pushService', ['$q', 'authService', '$http', '$rootScope', 'gameService', '$state', function ($q, authService, $http, $rootScope, gameService, $state) {
	var service = this;

	service.running = false;

	service.ensureRunning = function() {
		return $q(function(resolve, reject) {
			if (service.running) {
				resolve();
				return;
			}
			window.exo.performOperation('Exo.PushMessage.Initialize').then(function() {
				console.log('pushService: initialized');
				window.exo.addBroadcastListener(function(name, args) {
					if (name == 'Exo.PushMessage.TokenUpdated') {
						gameService.setPushToken(args.token).then(function() {
							console.log('pushService: updated token via gameService');
						}, function(err) {
							console.log('pushService: token update via gameService failed');
						});
					} else if (name == 'Exo.PushMessage.PushMessageClicked') {
						console.log('pushService: push message clicked. url=' + args.url);
						if (args.url == "fagligedage://messages") {
							$state.go('student.messages');
						}
					}
				});
				service.running = true;

				window.exo.performOperation('Exo.PushMessage.GetToken').then(function(result) {
					var token = JSON.parse(result.jsonData);
					console.log('pushService: got token via Exo.PushMessage.GetToken');
					gameService.setPushToken(token).then(function() {
						console.log('pushService: updated token via gameService');
					}, function(err) {
						console.log('pushService: token update via gameService failed');
					});
				}, function(err) {
					console.log('pushService: no token available via Exo.PushMessage.GetToken');
				});

				resolve();
			}, function(err) {
				console.log('pushService: failed to initialize: ' + err);
				reject();
			});
		});
	}

	return service;
}]);
